import { apiSlice } from "redux/api/baseApiSlice";
import { User } from "types/user";

export const userApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getUserData: builder.query<User, void>({
            query: () => '/negotiation/negotiations/user/',
        }),
        getHatoToken: builder.query<{token: string | null, refresh: string | null, hato_url: string | null, ws_url: string | null}, {}>({
            query: () => ({ url: "/hato/hato-get-token/", params: {scope: "negotiation"}  }),
        }),
    })
})

export const { useLazyGetUserDataQuery,useGetUserDataQuery, useGetHatoTokenQuery } = userApiSlice